import { gql } from '@apollo/client';

export const ParagraphActivityPoiProductsInRegionFragment = gql`
  fragment ParagraphActivityPoiProductsInRegion on ParagraphActivityPoiProductsInRegion {
    id
    title
  }
`;
